import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
class MultiContractOrgRelationsList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      multiContractData: {}
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.multiContractOrgRelations !== this.props.multiContractOrgRelations) {
      const mcors = this.props.multiContractOrgRelations.map(mcor =>
        _.mapValues(mcor, value => value || ''));
      const mcorData = _.fromPairs(mcors.map(mcor =>
        [mcor.externalGroupRelationId, _.omit(mcor, ['externalGroupRelationId'])]));
      this.setState({ mcorData });
    }
  }

  render() {
    return (
      <div className="multi_contract_list">
        {!_.isEmpty(this.props.multiContractOrgRelations.concat(this.props.newMultiContractOrgRelations)) &&
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Primary Organization</th>
                <th>Secondary Organization</th>
              </tr>
            </thead>
            <tbody>
              {this.props.multiContractOrgRelations.concat(this.props.newMultiContractOrgRelations).map(mcor => {
                return (
                  <tr key={mcor.id}>
                    <td>{mcor.id}</td>
                    <td>{mcor.primary_organization_name}</td>
                    <td>{mcor.secondary_organization_name}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>}
      </div>
    );
  }
}

MultiContractOrgRelationsList.propTypes = {
  multiContractOrgRelations:    PropTypes.array,
  newMultiContractOrgRelations: PropTypes.array,
  hasBillingAccess:             PropTypes.bool
};

//const mapStateToProps = state => ({
//});

//const mapDispatchToProps = {
//};

//export default connect(mapStateToProps, mapDispatchToProps)(MultiContractOrgRelationsList);
export default connect()(MultiContractOrgRelationsList);
